import $ from 'jquery';
import boostrap from 'bootstrap';

// Bootstrap
import "bootstrap/dist/js/bootstrap.bundle";

var theParent = document.querySelector("#modalContainer");
if (theParent) {
  theParent.addEventListener("click", activateModal, false);
}

function activateModal(e) {

  // var modal = document.getElementById('myModal');
  var modal = document.getElementById(e.target.id + 'Modal');
  modal.style.display = "block";

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
}

$(document).ready(function () {
  /* removes text from search form on focus and replaces it on unfocus - if text is entered then it does not get replaced with default on unfocus */
  // $('#SearchForm_SearchForm_action_results').val('L');
  var searchField = $('#SearchForm_SearchForm_Search');
  var default_value = searchField.val();
  var searchSubmitButton = $('#SearchForm_SearchForm_action_results');
  var fullScreenMenuButton = $('#fullScreenMenu_button');
  var fullScreenMenuOverlay = $('#fullScreenMenu_overlay');
  var component = $(this);
  var header = $('header');
  var body = $('body');

  clearSearch(component, searchField, searchSubmitButton);
  $(document).on("scroll", { header: header, body: body }, headerOnScroll);

  searchField.attr('autocomplete', 'off');

  if (fullScreenMenuButton.length) {
    fullScreenMenuButton.on('click', fullScreenMenuOnClick);
  }

  /*
   * Display fixed navigation when user scrolls down.
   * @param event {Event} Scroll event object.
   * @param navWrapper {Object} Scroll event object.
   */

  function fullScreenMenuOnClick() {
    $(this).toggleClass('active');
    fullScreenMenuOverlay.toggleClass('open');
  }

  /*
   * Removes text from search form on focus and replaces it on unfocus.
   * If text is entered then it does not get replaced with default on unfocus.
   * @param component {Object} Search form.
   * @param searchField {Object} Search field.
   * @param searchSubmitButton {Object} Search button.
   */

  function clearSearch(component, searchField, searchSubmitButton) {

    searchSubmitButton.val('L');
    var default_value = searchField.val();

    searchField.focus(function () {
      component.addClass('active');
      if (searchField.val() == default_value) {
        searchField.val('');
      }
    });

    searchField.blur(function () {
      if (searchField.val() == '') {
        searchField.val(default_value);
      }
    });
  }

  /*
   * Display fixed navigation when user scrolls down.
   * @param event {Event} Scroll event object.
   * @param navWrapper {Object} Scroll event object.
   */

  function headerOnScroll(event) {

    var header = event.data.header;
    var body = event.data.body;
    var scrollPos = $(document).scrollTop();

    if (scrollPos > 250) {
      header.addClass('fixed');
      body.addClass('headerPadding');
    } else {
      header.removeClass('fixed');
      body.removeClass('headerPadding');
    }
  }

  searchField.focus(function () {
    $(this).addClass('active');
    if (searchField.val() == default_value) {
      searchField.val('');
    }
  });
  searchField.blur(function () {
    if (searchField.val() == '') {
      searchField.val(default_value);
    }
  });

  if (!$.support.msie || ($.support.msie && (parseInt($.support.version, 10) > 8))) {
    var searchBarButton = $("span.search-dropdown-icon");
    var searchBar = $('div.search-bar');
    var menuButton = $("span.nav-open-button");
    var menu = $('.header .primary ul');
    var mobile = false;
    var changed = false;

    $('body').append('<div id="media-query-trigger"></div>');

    function menuWidthCheck() {
      var header_w = $('header .inner').width();
      var elements_w = menu.width() + $('.brand').width();

      if ((header_w < elements_w) || ($(window).width() <= 768)) {
        $('body').addClass('tablet-nav');
      }
      else {
        $('body').removeClass('tablet-nav');
      }

      // mobile_old = mobile;
      // if ($('#media-query-trigger').css('visibility') == 'hidden') {
      //   mobile = false;
      // }
      // else {
      //   mobile = true;
      // }

      // if (mobile_old != mobile) {
      //   changed = true;
      // }
      // else {
      //   changed = false;
      // }
    }

    menuWidthCheck();

    $(window).resize(function () {
      menuWidthCheck();

      if (!mobile) {
        menu.show();
        searchBar.show();
      }
      else {
        if (changed) {
          menu.hide();
          searchBar.hide();
        }
      }
    });

    /* toggle navigation and search in mobile view */
    searchBarButton.click(function () {
      menu.slideUp();
      searchBar.slideToggle(200);
    });

    menuButton.click(function () {
      searchBar.slideUp();
      menu.slideToggle(200);
    });
  }

  $('.scroll_link').each(function (index) {
    $(this).on('click', function (e) {
      e.preventDefault();
      $.scrollTo($(this).data('scrolltoTarget'), {
        offsetTop: 70,
        duration: 250
      });
    });
  });
});
